import React from "react";

const ProjectItems = ({ item }) => {
  const isWeb = item.category === "web";
  const isGame = item.category === "game";
  const isDeployed = item.deployed === "true";
  return (
    <div className="project__card" key={item.id}>
      <img src={item.image} alt="" className="project__image" />
      <h3 className="project__title">{item.title}</h3>
      <div className="project__buttons">
        <a
          href={item.repo}
          target="_blank"
          rel="noopener noreferrer"
          className="project__button"
        >
          Repo
          <i className="bx bx-right-arrow-alt project__button-icon"></i>
        </a>
        {isWeb && isDeployed && (
          <>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="project__button"
            >
              Demo
              <i className="bx bx-right-arrow-alt project__button-icon"></i>
            </a>
          </>
        )}

        {isGame && item.downloadPath && (
          <a href={item.downloadPath} download className="project__button">
            Download
            <i className="bx bx-right-arrow-alt project__button-icon"></i>
          </a>
        )}
      </div>
    </div>
  );
};

export default ProjectItems;
